import { Miniature } from '../../../../models';

export function createIdentifierQueryMiniatures(): Miniature[] {
    const miniatures = [];
    miniatures.push({
        group: 'templates',
        create: () => {},
        highlights: ['An identifier query'],
        icon: 'fa-filter',
        sortingOrder: 1,
        title: 'Identifier query',
        type: 'identifierQuery'
    });
    return miniatures;
}